// Report content view component/element display bit flags.
export const REPORTVIEW_FLAGS_NONE = 0x00
export const REPORTVIEW_FLAGS_TABLE_SHOW_HEADER_ROW = 0x01 // Show the report header row.
export const REPORTVIEW_FLAGS_TABLE_SHOW_FOOTER_ROW = 0x02 // Show the report footer row.
export const REPORTVIEW_FLAGS_TABLE_SHOW_CONTENT_ROWS = 0x04 // Show the main content rows.
export const REPORTVIEW_FLAGS_TABLE_SHOW_SPACER_ROWS = 0x08 // Show the additionally automatically generated spacer rows before the footer row for short reports.
export const REPORTVIEW_FLAGS_TABLE_ALL =
    REPORTVIEW_FLAGS_TABLE_SHOW_HEADER_ROW |
    REPORTVIEW_FLAGS_TABLE_SHOW_FOOTER_ROW |
    REPORTVIEW_FLAGS_TABLE_SHOW_CONTENT_ROWS |
    REPORTVIEW_FLAGS_TABLE_SHOW_SPACER_ROWS // All table orientated configuration flags.
export const REPORTVIEW_FLAGS_BLF_SHOW_LARGE_TOOLTIPS = 0x0100 // BLF (icon) view supports large tooltips.
export const REPORTVIEW_FLAGS_BLF_AUTOMATIC_TEXT_TRUNCATION_ADJUSTMENTS = 0x0200 // BLF (icon) view supports automatic text adjustment truncation for long caption texts.
export const REPORTVIEW_FLAGS_PRINT_RPTINFO = 0x010000 // Whether the report information header area is shown in the printable output of reports.
// Default flags for report output shown in the Reporting Portal window.
export const REPORTVIEW_FLAGS_DEFAULT_PORTAL =
    REPORTVIEW_FLAGS_TABLE_ALL |
    REPORTVIEW_FLAGS_BLF_SHOW_LARGE_TOOLTIPS |
    REPORTVIEW_FLAGS_BLF_AUTOMATIC_TEXT_TRUNCATION_ADJUSTMENTS
// Default flags for report output shown in the the printable output of reports.
export const REPORTVIEW_FLAGS_DEFAULT_PRINT = REPORTVIEW_FLAGS_TABLE_ALL | REPORTVIEW_FLAGS_PRINT_RPTINFO
